angular.module('qkr.partner.reports').config($routeSegmentProvider => {
    const reportsResolve = {
        reports(reportService) {
            'ngInject';
            return reportService.loadSavedFinance1PartnerReports();
        }
    };

    $routeSegmentProvider
        .when('/mastercard/reports', 'partnerreports',  { pageTitle: 'Reports' })
        .when('/mastercard/reports/view', 'partnerreports.view')
        .when('/mastercard/reports/schedule', 'partnerreports.schedule')
        .when('/mastercard/reports/current', 'partnerreports.current');

    $routeSegmentProvider
        .segment('partnerreports', {
            template: '<partnerreports></partnerreports>'
        })
        .within()
        .segment('view', {
            default: true,
            template: require('./view/view.html'),
            controller: 'ViewPartnerReportsController',
            controllerAs: 'vm',
            resolve: {},
            untilResolved: {template: require('../../shared/loading-screen.html')},
            resolveFailed: {template: require('../../shared/loading-error.html')}
        })
        .segment('schedule', {
            template: require('./schedule/schedule.html'),
            controller: 'SchedulePartnerReportsController',
            controllerAs: 'vm',
            resolve: reportsResolve,
            untilResolved: {template: require('../../shared/loading-screen.html')},
            resolveFailed: {template: require('../../shared/loading-error.html')}
        })
        .segment('current', {
            template: require('./current/current.html'),
            controller: 'CurrentPartnerReportsController',
            controllerAs: 'vm',
            resolve: reportsResolve,
            dependencies: [],
            untilResolved: {template: require('../../shared/loading-screen.html')},
            resolveFailed: {template: require('../../shared/loading-error.html')}
        });
});



// WEBPACK FOOTER //
// ./src/reports/partner/partnerreports.config.js